import {gql} from 'apollo-angular';


export const addressBookGql = gql`
query ReloadConstituentAddressBookGql($individualConstituentId: [Int!]) {
    IndividualConstituent(individualConstituentId: $individualConstituentId) {
        constituentAddressBooks {
          email
          firstName
          lastName
          firstDonationDate
          lastDonationDate
          constituentAddressBookId
        }
    }
}
`;